module.exports = __webpack_public_path__ + "static/gatsby-9494876fd7939bfa58ffb236e8e8ec0c.png";